﻿import React, { Fragment, useContext, useReducer, useEffect } from 'react';
import moment from 'moment';

import { products } from "../Endpoints"
import { BookingFlowContext } from '../BookingFlowContext'
import { usePrevious } from '../hooks/usePrevious'
import { validateFormObjectAlt } from '../Validation'
import { parseDate } from '../../../../../Resources/Scripts/_Shared/parseDate'
//import { formatCurrency } from '../../../../Components/Pages/BookingFlowPage/Scripts/Currency'
// import { useProductAvailability } from '../hooks/useProductAvailability'

import { HeadingAndText } from '../partials/HeadingAndText'
import { Error } from '../../../../../Resources/Scripts/_Shared/elements/Error'
import { DateAndProductSelection } from '../partials/DateAndProductSelection'

import { DateSelectionWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/DateSelectionWithLabel'
import { Divider } from '../../../../../Resources/Scripts/_Shared/elements/Divider'
import { InputWithLabel  } from '../../../../../Resources/Scripts/_Shared/elements/InputWithLabel'
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { CheckboxWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/CheckboxWithLabel'

const ACTIONS = {
  OVERRIDE: 'override-state',
  DATE: 'update-date',
  TIME: 'update-time',
  END_DATE: 'update-end-date',
  END_TIME: 'update-end-time',
  CLEAR_END_DATE_TIME: 'clear-end-date-time',
  PRODUCT: 'update-product',
  PRODUCT_AVAILABLE: 'available-product',
  PENDING: 'pending',
  PENDING_TRUE: 'pending-true',
  PENDING_FALSE: 'pending-false',
  PRE_PRICE: 'set-prebooking-price',
  FLEX_PRICE: 'set-flex-price',
  FLEX_PRICE_PENDING: 'pending-price',
  FLEX_PRICE_ERROR: 'error-price',
  INSURANCE_FEE: 'insurance-fee',
}
const emptyGuid = '00000000-0000-0000-0000-000000000000';

const initialState = (lang) => {
  return {
    form: {
      date: { date: new URLSearchParams(window.location.search).get('date'), dayOfWeek: -1, required: true, elementType: 'date' },
      time: { text: '', required: false },
      endDate: { date: null, required: false, elementType: 'date' },
      endTime: { text: '', required: false },
      productSelection: { item: { Text: lang.chooseproduct, Id: emptyGuid, ZoneAndProduct: emptyGuid, initial: true }, required: true, elementType: 'select' },
      numberOfParkingSpots: { number: 1, elementType: 'number' },
      //paymentSelection: { item: { id: emptyGuid, initial: true }, elementType: 'radio' },
      insuranceFee: { selected: false, required: false, elementType: 'checkbox' },
      preBookingPrice: null,
      calculatedFlexPrice: null,
      errorPrice: false,
      availableProduct: true,
    },
    //data: {
    //  availableProducts: null,
    //  availableSpots: null,
    //},
    pending: false,
    pendingPrice: false,
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.OVERRIDE:
      return { ...state, form: { ...action.payload }};
    case ACTIONS.DATE:
      return { ...state, form: { ...state.form, date: action.payload }};
    case ACTIONS.TIME:
      return { ...state, form: { ...state.form, time: action.payload }};
    case ACTIONS.END_DATE:
      return { ...state, form: { ...state.form, endDate: action.payload }};
    case ACTIONS.END_TIME:
      return { ...state, form: { ...state.form, endTime: action.payload }};
    case ACTIONS.CLEAR_END_DATE_TIME:
      return { ...state, form: { ...state.form, time: { ...state.form.time, text: '' }, endDate: { ...state.form.endDate, date: null }, endTime: { ...state.form.endTime, text: '' }, calculatedFlexPrice: null }};
    case ACTIONS.PRE_PRICE:
      return { ...state, form: { ...state.form, preBookingPrice: { text: action.payload }, calculatedFlexPrice: null }};
    case ACTIONS.FLEX_PRICE:
      return { ...state, form: { ...state.form, preBookingPrice: null, calculatedFlexPrice: { text: action.payload } }, pendingPrice: false };
    case ACTIONS.FLEX_PRICE_PENDING:
      return { ...state, pendingPrice: action.payload };
    case ACTIONS.FLEX_PRICE_ERROR:
      return { ...state, form: { ...state.form, errorPrice: action.payload } };
    case ACTIONS.PRODUCT: {
      const isFlex = action.payload.item.ProcessType === 'Flexbooking';
      return {
        ...state,
        form: {
          ...state.form,
          productSelection: action.payload,
          //date: { ...state.form.date, required: !isFlex, error: null },
          time: { ...state.form.time, required: isFlex, error: null },
          endDate: { ...state.form.endDate, required: isFlex, error: null },
          endTime: { ...state.form.endTime, required: isFlex, error: null }
        }
      };
    }
    case ACTIONS.PRODUCT_AVAILABLE:
      return { ...state, form: { ...state.form, availableProduct: action.payload } };
    case ACTIONS.INSURANCE_FEE:
      return { ...state, form: { ...state.form, insuranceFee: action.payload } };
    case ACTIONS.PENDING:
      return { ...state, pending: action.payload };
    case ACTIONS.PENDING_TRUE:
      return { ...state, pending: true };
    case ACTIONS.PENDING_FALSE:
      return { ...state, pending: false };
    default: {
      console.log('No reducer action specified.');
      return state;
    }
  }
}

const OnlineBookingStp = () => {
  const {bookingFlowContext, setBookingFlowContext} = useContext(BookingFlowContext);
  const currentStepFormData = bookingFlowContext.availableSteps.onlineBooking.formData ?? {};
  const formLang = {
    ...bookingFlowContext.localization.global,
    ...bookingFlowContext.localization.onlineBooking,
    language: bookingFlowContext.localization.language,
  }

  const [stepState, dispatch] = useReducer(reducer, currentStepFormData.date ? { ...initialState(formLang), form: currentStepFormData } : initialState(formLang));
  const prevStepState = usePrevious(stepState);

  const language = bookingFlowContext.localization.language;
  const country = bookingFlowContext.country;
  const selectedLocale = country === 'no' ? 'nb' : country === 'se' ? 'sv' : country;
  const selectedLanguage = language === 'no' ? 'nb' : language === 'se' ? 'sv' : language;

  //const [productAvailability, productAvailabilityCount, pendingAvailability] = useProductAvailability(stepState.form.productSelection.item, stepState.form.date.date, bookingFlowContext);

  let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === 'Flexbooking' : null;

  const onlineBookingHandler = () => {
    let [updatedForm, formValidationError] = validateFormObjectAlt(stepState.form, formLang.errorMessages);
    if (formValidationError) {
      dispatch({type: ACTIONS.OVERRIDE, payload: updatedForm })
      return;
    }

    let activeStep = null;
    let user = null;

    if (bookingFlowContext.episerver.loggedIn) {
      user = {
        email: bookingFlowContext.episerver.emailAddress,
        givenName: bookingFlowContext.episerver.given_name,
        familyName: bookingFlowContext.episerver.family_name,
      }

      if (bookingFlowContext.episerver.hasWebticketAccount) {
        activeStep = bookingFlowContext.availableSteps.addVehicle.index;
      } else {
        activeStep = bookingFlowContext.availableSteps.createAccount.index;
      }
    } else {
      activeStep = bookingFlowContext.availableSteps.login.index;
    }

    setBookingFlowContext({
      ...bookingFlowContext,
      user,
      activeStep,
      availableSteps: {
        ...bookingFlowContext.availableSteps,
				onlineBooking: {
          ...bookingFlowContext.availableSteps.onlineBooking,
          formData: {
            ...updatedForm
          }
				},
        addVehicle: {
          ...bookingFlowContext.availableSteps.addVehicle,
          formData: bookingFlowContext.availableSteps.onlineBooking.formData?.productSelection.item.Type === stepState.form.productSelection.item.Type ? bookingFlowContext.availableSteps.addVehicle.formData : null
        }
      }
    })
  };

  useEffect(() => {
    let subscribe = true;
    let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === 'Flexbooking' : null;

    if (!stepState.form.date.date || stepState.form.productSelection.item.initial)
      return;

    if (!stepState.form.productSelection.item.CancellationInsuranceFee) {
      dispatch({type: ACTIONS.INSURANCE_FEE, payload: false })
    }

    if (!isFlexBooking) {
      dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: true })

      const getAvailability = async () => {
        const data = {
          bookingController: bookingFlowContext.episerver.bookingController,
          pmcId: stepState.form.productSelection.item.Id,
          startDate: stepState.form.date.date,
        }

        const productAvailability = await products.getAvailability(data, bookingFlowContext.useMockedData);
        const availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;

        if (availableSpotsCount === 0) {
          dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: false })
          dispatch({type: ACTIONS.PRE_PRICE, payload: null })
          return;
        }

        //Check Prebooking price from "WeekdayPrices"
        if(stepState.form.date.dayOfWeek > -1 && stepState.form.productSelection.item.WeekdayPrices) {
          dispatch({type: ACTIONS.PRE_PRICE, payload: stepState.form.productSelection.item.WeekdayPrices[stepState.form.date.dayOfWeek] })
        } else {
          dispatch({type: ACTIONS.PRE_PRICE, payload: null })
        }
      }
      getAvailability();

      return;
    }

    if (!stepState.form.time.text || !stepState.form.endDate.date || !stepState.form.endTime.text)
      return;

    if (stepState.form.date.date == stepState.form.endDate.date && parseFloat(stepState.form.endTime.text.replace(':', '.')) <= parseFloat(stepState.form.time.text.replace(':', '.'))) {
      console.log(`End time (${stepState.form.endTime.text}) should be AFTER start time (${stepState.form.time.text}).`);
      return;
    }

    const getPrice = async () => {
      dispatch({type: ACTIONS.FLEX_PRICE_PENDING, payload: true })
      dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: true })

      const startDate = `${stepState.form.date.date} ${stepState.form.time.text}`;
      const endDate = `${stepState.form.endDate.date} ${stepState.form.endTime.text}`;
      const data = {
        bookingController: bookingFlowContext.episerver.bookingController,
        pmcId: stepState.form.productSelection.item.Id,
        startDate,
        endDate
      }

      const productAvailability = await products.getAvailability(data, bookingFlowContext.useMockedData);
      const availableSpotsCount = productAvailability.status === 200 ? productAvailability.body.Availability ?? 0 : 0;

      if (availableSpotsCount === 0) {
        dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: false })
        dispatch({type: ACTIONS.FLEX_PRICE_PENDING, payload: false })
        dispatch({type: ACTIONS.FLEX_PRICE, payload: null })
        return;
      }

      const flexBookingPrice = await products.getFlexbookingPrice(data, bookingFlowContext.useMockedData, formLang.language);

      if (subscribe && flexBookingPrice.status === 200) {
        dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: true })
        dispatch({type: ACTIONS.FLEX_PRICE, payload: flexBookingPrice.body.Price })
      }
      else if (subscribe) {
        dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: false })
        dispatch({type: ACTIONS.FLEX_PRICE_ERROR, payload: true })
      }

      dispatch({type: ACTIONS.FLEX_PRICE_PENDING, payload: false })
    }
    getPrice();

    return () => subscribe = false;
  }, [stepState.form.date, stepState.form.time, stepState.form.endDate, stepState.form.endTime, stepState.form.productSelection])

  useEffect(() => {
    if (!stepState || !prevStepState)
      return;

    dispatch({type: ACTIONS.PRODUCT_AVAILABLE, payload: true })

    let isFlexBooking = !stepState.form.productSelection.item.initial ? stepState.form.productSelection.item.ProcessType === 'Flexbooking' : null;
    let wasFlexBooking = !prevStepState.form.productSelection.item.initial ? prevStepState.form.productSelection.item.ProcessType === 'Flexbooking' : null;

    if (!isFlexBooking && wasFlexBooking)
      dispatch({type: ACTIONS.CLEAR_END_DATE_TIME })

  }, [stepState.form.productSelection])

  const flexStartDate = moment().add(0, 'days').toDate();

  return (
    <Fragment>
      <DateAndProductSelection
        bookingFlowContext={bookingFlowContext}
        formLang={formLang}
        pending={stepState.pending}
        date={stepState.form.date}
        productSelection={stepState.form.productSelection}
        setPending={(value) => dispatch({type: ACTIONS.PENDING, payload: value })}
        setDate={(value) => dispatch({type: ACTIONS.DATE, payload: value })}
        setProductSelection={(value) => dispatch({type: ACTIONS.PRODUCT, payload: value })}
        dateDisabled={!stepState.form.productSelection.item.initial && isFlexBooking}
        startDate={flexStartDate}/>

      {!isFlexBooking && stepState.form.date.dayOfWeek > -1 && !stepState.form.productSelection.item.initial &&
        <Fragment>
          {stepState.form.preBookingPrice && stepState.form.preBookingPrice.text && <p className="flex-price">Your price: {<span>{stepState.form.preBookingPrice.text} {stepState.form.productSelection.item.Currency}</span>}</p>}
          {(stepState.form.preBookingPrice && !stepState.form.preBookingPrice.text) && <Fragment><Divider /><Error text={formLang.availableparkingspotsinfonone} /></Fragment>}
        </Fragment>
      }

      {isFlexBooking && !stepState.form.productSelection.item.initial &&
        <Fragment>
          <Divider />
          <h3>{formLang.flexheading}</h3>
          <TwoColumnWrapper>
            <TwoColumnWrapper>
            <DateSelectionWithLabel extraClass="startdate" text={formLang.flexstartdate} extraText={' ' + formLang.flexandtime} value={stepState.form.date} setValue={(value) => dispatch({ type: ACTIONS.DATE, payload: value })} placeholder={formLang.selectdate} locale={selectedLocale} language={selectedLanguage} selectedDays={[stepState.form.date.date && new Date(parseDate(stepState.form.date.date)), { from: stepState.form.date.date && new Date(parseDate(stepState.form.date.date)), to: stepState.form.endDate.date && new Date(parseDate(stepState.form.endDate.date)) }]} disabledDays={stepState.form.endDate.date && { before: flexStartDate, after: new Date(parseDate(stepState.form.endDate.date)) }} month={stepState.form.date.date ? new Date(parseDate(stepState.form.date.date)) : flexStartDate} fromMonth={flexStartDate} startDate={flexStartDate}/>
            <InputWithLabel inputType="time" text={formLang.flexstarttime} value={stepState.form.time} setValue={(value) => dispatch({type: ACTIONS.TIME, payload: value })} debounce={750} />
            </TwoColumnWrapper>
            <TwoColumnWrapper>
            <DateSelectionWithLabel extraClass="enddate" text={formLang.flexenddate} extraText={' ' + formLang.flexandtime} value={stepState.form.endDate} setValue={(value) => dispatch({ type: ACTIONS.END_DATE, payload: value })} placeholder={formLang.selectdate} locale={selectedLocale} language={selectedLanguage} selectedDays={[stepState.form.date.date && new Date(parseDate(stepState.form.date.date)), { from: stepState.form.date.date && new Date(parseDate(stepState.form.date.date)), to: stepState.form.endDate.date && new Date(parseDate(stepState.form.endDate.date)) }]} disabledDays={{ before: stepState.form.date.date ? new Date(parseDate(stepState.form.date.date)) : flexStartDate }} month={stepState.form.date.date && new Date(parseDate(stepState.form.date.date))} fromMonth={stepState.form.date.date && new Date(parseDate(stepState.form.date.date))} startDate={flexStartDate}/>
            <InputWithLabel inputType="time" text={formLang.flexendtime} value={stepState.form.endTime} setValue={(value) => dispatch({ type: ACTIONS.END_TIME, payload: value })} debounce={750} />
            </TwoColumnWrapper>
          </TwoColumnWrapper>
          {((stepState.pendingPrice || stepState.form.calculatedFlexPrice) && stepState.form.availableProduct) &&
            <p className="flex-price">
              Your price: {stepState.pendingPrice ?
                <span className="loading"><span className="aimo-spinner"><span></span><span></span><span></span><span></span></span></span> :
                <span>{stepState.form.calculatedFlexPrice.text}</span>}
            </p>
          }
          {(isFlexBooking && !stepState.form.availableProduct) &&
            <Error text={formLang.availableparkingspotsinfonone} />
          }
        </Fragment>
      }

      {!stepState.form.productSelection.item.initial && stepState.form.productSelection.item.CancellationInsuranceFee &&
        <Fragment>
          <Divider />
          <HeadingAndText heading={formLang.otheroptionsheading} text={formLang.insurancefeetext}>
            <CheckboxWithLabel text={`${stepState.form.productSelection.item.CancellationInsuranceFee.Heading}: ${stepState.form.productSelection.item.CancellationInsuranceFee.Price.replace('.', ',')} ${stepState.form.productSelection.item.Currency}`} value={stepState.form.insuranceFee} setValue={(value) => dispatch({type: ACTIONS.INSURANCE_FEE, payload: value })} />
          </HeadingAndText>
        </Fragment>
      }

      {stepState.form.productSelection.item.ExtraFee &&
        <Fragment>
          <Divider />
          <HeadingAndText heading={stepState.form.productSelection.item.ExtraFee.Heading} text={stepState.form.productSelection.item.ExtraFee.Text} />
        </Fragment>
      }

      <Divider />
      <button className="single-step__button single-step__button--next" onClick={onlineBookingHandler} disabled={stepState.form.productSelection.item.initial || (!isFlexBooking && (!stepState.form.preBookingPrice || !stepState.form.preBookingPrice.text)) || (isFlexBooking && (stepState.pendingPrice || !stepState.form.calculatedFlexPrice))}>{formLang.buttons.nextStep}</button>
    </Fragment>
  )
}

export default OnlineBookingStp;
